import {PageFragment, PageFragmentProps} from "@/shared/PageFragment";
import {Box} from "@mui/material";
import {FormGenContainer, FormGenContainerMode} from "@/shared/FormGenContainer";
import {PAGE_FRAGMENT_LG_WIDTH} from "@/shared/dimens";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React from "react";
import {PatientProfile, PracticeData} from "../types";

export type AddPatientProfileInput = {
  firstname?: string,
  lastname?: string,
  phoneNumber?: string,
  email?: string,
}

function PatientProfileFromInput(input: AddPatientProfileInput): PatientProfile {
  const profile = PatientProfile.createNew();
  profile.basicInfo.firstname = input.firstname;
  profile.basicInfo.lastname = input.lastname;
  profile.basicInfo.phoneNumber = input.phoneNumber;
  profile.basicInfo.email = input.email;
  return profile;
}

export class EditPatientProfileHelper {

  static addPatientProfile(input?: AddPatientProfileInput): void {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditPatientProfileFragment input={input}
                                        onPatientProfileSaved={patientProfile => BaseApp.CONTEXT.hideDialog()}/>);
  }

  static editPatientProfile(patientProfile: PatientProfile) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditPatientProfileFragment edit={patientProfile}
                                        onPatientProfileSaved={patientProfile => BaseApp.CONTEXT.hideDialog()}/>);
  }
}

type EditPatientProfileFragmentProps = PageFragmentProps & {
  input?: AddPatientProfileInput,
  edit?: PatientProfile,
  onPatientProfileSaved: (patientProfile: PatientProfile) => void,
}

class EditPatientProfileFragment extends PageFragment<EditPatientProfileFragmentProps> {

  private readonly patientProfiles = PracticeData.provider().patientProfiles;
  private readonly patientProfile = this.props.edit ? this.props.edit : PatientProfileFromInput(this.props.input);

  protected onCreateState() {
    return {
      ...super.onCreateState(),
      title: this.props.edit ? "Edit Patient" : "Add Patient",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return this.props.edit ? "Save" : "Add";
  }

  onActionButtonClicked() {
    this.addPatientProfile().then(() => this.props.onPatientProfileSaved(this.patientProfile));
  }

  private async addPatientProfile() {
    await this.patientProfiles.addListItem(this.patientProfile);
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", width: "84dvw", maxWidth: PAGE_FRAGMENT_LG_WIDTH}}>
      <FormGenContainer
        mode={this.props.edit ? FormGenContainerMode.EDIT : FormGenContainerMode.CREATE}
        content={this.patientProfile}
        onContainerRequiredItemsFilledChanged={(container, filled) => this.setActionButtonEnabled(filled)}/>
    </Box>;
  }
}
